import {SODeleteAssessment} from '../../core/assessment/so-delete-assessment';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeleteAssessment extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeleteAssessment;
}